export const ModalSucces = ({ message, hideModal }) => {
  setTimeout(() => {
    hideModal();
  }, 2000);
  return (
    <div
      style={{
        width: "80%",
        height: "50px",
        position: "absolute",
        top: "40px",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "white",
        padding: "20px",
        borderRadius: "10px",
        zIndex: "15",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "rgb(0 0 0 / 28%) 1px 1px 10px 0px",
        fontSize: "1.2rem",
        fontFamily: "Montserrat",
        textAlign: "center",
      }}
    >
      <p style={{ color: "#93C155", fontWeight: "bold" }}>{message}</p>
    </div>
  );
};
